import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { usePreloadImages } from '../../utils/image-loading/usePreloadImages'
import { MutualFundDetailSubSections } from '../../types/mutual-fund-detail.types'
import { renderSubSection } from '../../utils/sectionsConfig'

export const ReturnsGraph = ({ subsections }: { subsections: `${MutualFundDetailSubSections}`[] }) => {
  usePreloadImages([`${MUTUAL_FUND_DETAIL_IMAGE_URL}/rank-boxes.svg`])

  return (
    <div className='bg-white rounded-xl py-1'>
      {subsections?.map((subsection, idx) => {
        return renderSubSection({ componentKey: subsection, customProps: { isBorderTop: idx !== 0 } })
      })}
    </div>
  )
}
